export const defaultMemberSignInFormEmailFieldDisplayText = {
    label: 'Email',
    requiredMessage: 'Email is required.',
    formatMessage: 'The email you entered has an invalid format.'
};
export const defaultMemberSignInFormUsernameFieldDisplayText = {
    label: 'Username',
    requiredMessage: 'Username is required.',
    formatMessage: 'The username you entered has an invalid format.'
};
export const defaultMemberSignInFormPasswordFieldDisplayText = {
    label: 'Password',
    requiredMessage: 'Password is required.'
};
export const defaultMemberSignInFormRememberFieldDisplayText = {
    label: 'Keep me signed in',
    requiredMessage: 'Keep me signed in is required.'
};
